// extracted by mini-css-extract-plugin
export default {"login":"login_login__nRn4+","innerLogin":"login_innerLogin__D7WB9","selectedOTPCard":"login_selectedOTPCard__c3NWO"};